import type { AppRouteDefinition } from './routes';
import type { NavItem } from '@/components/sidebarTypes';

export const getNavItemsFromRoutes = (routes: AppRouteDefinition[]): NavItem[] => {
  const routePaths = new Set(routes.map((route) => route.path));
  return routes.flatMap((route) => {
    if (route.devOnly && !import.meta.env.DEV) return [];
    if (!route.nav) return [];
    const hasSecondary = route.nav.secondaryPath ? routePaths.has(route.nav.secondaryPath) : false;
    return [
      {
        key: route.key,
        label: route.nav.label,
        icon: route.nav.icon,
        path: route.path,
        requiresAdmin: route.nav.requiresAdmin ?? route.requiresAdmin,
        requiresSuperuser: route.nav.requiresSuperuser ?? route.requiresSuperuser,
        secondary: hasSecondary ? route.nav.secondary : undefined,
        secondaryPath: hasSecondary ? route.nav.secondaryPath : undefined,
        disabled: route.nav.disabled,
        secondaryDisabled: route.nav.secondaryDisabled,
      },
    ];
  });
};
